import { BaseEditorState, FlowstepMeta } from '@v2/components/flowsteps/editors/common/states/base-editor-state';
import { makeAutoObservableExt } from '@v2/utils/mobx/make-auto-observable-ext';
import office from 'src/services/office';
import { capitalizeString } from 'shared/utils/utils';
import { NEW_WORKSHEET_ID } from '@v2/components/base/CellAddressPicker/hooks/useCellAddressValidation';
import { officeStore } from 'src/stores';
import { PullSettingsState } from '@v2/components/flowsteps/editors/common/states/pull-settings-state';
import { ProviderType, PullMode } from 'shared/types/flowstep';
import { PullOptionsState } from '@v2/components/flowsteps/editors/common/PullOptions/pull-options-state';

export abstract class PullEditorState extends BaseEditorState {
  public worksheetId: string | undefined = undefined;
  public pullMode = PullMode.OVERWRITE;
  public pullOptions = new PullOptionsState();
  public pullSettings: PullSettingsState;

  protected constructor(public flowstepMeta: FlowstepMeta) {
    super(flowstepMeta);
    this.pullSettings = new PullSettingsState(flowstepMeta.provider);
    makeAutoObservableExt(this, PullEditorState, {
      pullSettings: false,
      pullOptions: false,
    });
  }

  async saveFlowstep(options: { makeCopy?: boolean; targetFlowId?: string } = {}) {
    await this.prepareWorksheet();
    await super.saveFlowstep(options);
  }

  async prepareWorksheet() {
    if (this.pullSettings.createNewSheet) {
      const createdWorksheet = await office.createWorksheet(
        `${capitalizeString(this.pullSettings.selectedObject?.label)}`,
      );
      this.worksheetId = createdWorksheet.id;
      if (this.timestampCell?.worksheetId === NEW_WORKSHEET_ID) {
        this.timestampCell.worksheetId = createdWorksheet.id;
      }
    } else if (!this.worksheetId) {
      this.worksheetId = officeStore.activeWorksheetId;
    }
  }
}
